import R from 'app/assets/R'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { useTranslation } from 'react-i18next'
import { useDetailVoucherContext } from '../../context'

export const FooterLayout = () => {
  const { t } = useTranslation()
  const { handleGoBack } = useDetailVoucherContext()
  return (
    <BaseRow align={'middle'} justify={'end'}>
      <BaseCol>
        <BaseRow gutter={16} align={'middle'}>
          <BaseCol>
            <BaseButton onClick={handleGoBack}>
              {t(R.strings.back)}
            </BaseButton>
          </BaseCol>
        </BaseRow>
      </BaseCol>
    </BaseRow>
  )
}
